import React from "react";
import {
    Box,
    Typography,
    Grid,
    Card,
    CardContent,
    CardActionArea,
    styled,
    keyframes
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {MdDashboard, MdDashboardCustomize, MdOutlineCampaign, MdOutlineList} from "react-icons/md";
import {BiSolidOffer} from "react-icons/bi";
import {TbMenuOrder} from "react-icons/tb";
import {
    Campaign,
    CampaignTwoTone,
    Category,
    DashboardCustomize,
    ListAlt as SubListIcon,
    ListOutlined
} from "@mui/icons-material";
import {FaCartPlus, FaPlusCircle, FaSellcast, FaSolarPanel, FaUserCog, FaUsers} from "react-icons/fa";
import {GoPin} from "react-icons/go";
import {PiFlagBanner} from "react-icons/pi";
import {MdVerticalAlignTop} from "react-icons/md";
import {IoTicketOutline} from "react-icons/io5";
import {VscWorkspaceTrusted, VscWorkspaceUnknown} from "react-icons/vsc";
import {FiFileText, FiType} from "react-icons/fi";
import {FaCartShopping, FaUsersBetweenLines} from "react-icons/fa6";
import {SiGooglemarketingplatform} from "react-icons/si";
import {Can} from "../Can";

// Animation for card entrance
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

// Styled card component with hover effects
const DashboardCard = styled(Card)(({ theme }) => ({
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    transition: 'transform 0.3s, box-shadow 0.3s',
    animation: `${fadeIn} 0.5s ease-out`,
    '&:hover': {
        transform: 'translateY(-5px)',
        boxShadow: theme.shadows[8],
    },
}));

const CardTitle = styled(Typography)({
    fontWeight: 600,
    position: 'relative',
    paddingBottom: '8px',
    '&:after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        width: '40px',
        height: '3px',
        backgroundColor: '#3f51b5',
    },
});

export const ManageEmailsTable = () => {
    const navigate = useNavigate();

    // Card data - replace with your actual content
    const dashboardCards = [
        { id: 1, title: "Admin Campaign", path: "/Campaigns",icon : Campaign,permission:'adminCampaign',action:'index' },
        { id: 2, title: "User Campaign", path: "/UserCampaigns",icon : MdOutlineCampaign,permission:'userCampaign',action:'index'  },
    ];

    const handleCardClick = (path: string) => {
        navigate(path);
    };

    return (
        <Box sx={{ flexGrow: 1, p: 3 }}>
            <Typography variant="h4" gutterBottom sx={{
                fontWeight: 700,
                mb: 4,
                textAlign: 'center',
                color: 'text.primary'
            }}>
                Manage Emails
            </Typography>

            <Grid container spacing={3}>
                {dashboardCards.map((card) => (
                    <Can I={card.action} a={card.permission}>
                    <Grid item xs={12} sm={6} md={4} key={card.id}>
                            <DashboardCard>
                                <CardActionArea
                                    onClick={() => handleCardClick(card.path)}
                                    sx={{ height: '100%', p: 2 }}
                                >
                                    <CardContent sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        textAlign: 'center'
                                    }}>
                                        {/* Placeholder for icon - replace with your actual icon */}
                                        <Box sx={{
                                            width: 64,
                                            height: 64,
                                            bgcolor: 'primary.main',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            mb: 2,
                                            color: 'white',
                                            fontSize: '1.5rem'
                                        }}>
                                            {card.icon ? <card.icon className="" /> : card.title.charAt(0)}
                                        </Box>

                                        <CardTitle variant="h6" gutterBottom>
                                            {card.title}
                                        </CardTitle>

                                        <Typography variant="body2" color="text.secondary">
                                            Click to access {card.title.toLowerCase()}
                                        </Typography>
                                    </CardContent>
                                </CardActionArea>
                            </DashboardCard>
                    </Grid>
                    </Can>
                ))}
            </Grid>
        </Box>
    );
};